import brand, { colourWithTransparency } from '@helpers/brand';
import { Layers } from '@helpers/layers';
import { m } from 'framer-motion';
import styled from 'styled-components';
const LoadingIndicator = styled(m.div) `
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  display: grid;
  background: ${colourWithTransparency(brand.primary.blue.base, 0.6)};
  color: ${brand.white};
  place-content: center;
  place-items: center;
  width: 100%;
  z-index: ${Layers.Overlays};

  svg {
    height: 96px;
    width: 96px;
  }
`;
const ScrollLoaderStyles = {
    LoadingIndicator,
};
export default ScrollLoaderStyles;
